// @flow
import React from 'react'
import transDomain from './translations/index.translations'
import { Currency } from 'i18n/NumberFormatter'
import { withTranslation, Trans } from 'react-i18next'
import { Redirect, withRouter } from 'react-router-dom'

import supportedThemes from './themes/__supportedThemes'

import withTheme from 'hoc/withTheme'

import { Store } from 'Store.js'

import styles from './styles.module.scss'

function SuccessInfoArea ({ t, location, theme }) {
    const { state } = React.useContext(Store)
    const [redirect, setRedirect] = React.useState(false)
    const { email, newVehicleModel, newVehicleModelYear, firstName } = state.lead.fields
    const voucher = state.lead.incentives.voucher
    const currencyFormatter = Currency(state.currency, state.locale)

    const handleRedirect = React.useCallback(() => {
        setRedirect(true)
    }, [])

    if (redirect) {
        return <Redirect to={`${location.pathname.replace('success', 'step-1')}${location.search}`} push />
    }

    return (
        <div className={styles.container}>
            <div className={styles.separator} style={{
                borderColor: theme.ternaryColor,
            }}>
                <div className={styles.innerBox}>
                    <span style={{
                        color: theme.confirmColor
                    }}>
                        {t('confirm')}
                        <br />
                        <div className={styles.email} style={{
                            color: theme.secondaryColor,
                            backgroundColor: theme.bgEmailColor
                        }}>{email}</div>
                    </span>
                    <span className={styles.information} style={{
                        color: theme.informationColor
                    }}>
                        Not the correct email address? <strong onClick={handleRedirect} style={{ color: theme.primaryColor }}>Click Here</strong> to change.
                    </span>
                </div>
            </div>
            <span style={{
                color: theme.yearModelColor
            }} className={styles.yearModelTitle}>
                <strong className={styles.thanksMessage} style={{
                    color: theme.thanksMessageColor,
                }}>
                    <Trans i18nKey='thanksMessage' t={t} values={{
                        model: newVehicleModel,
                        year: newVehicleModelYear,
                        firstName: firstName,
                        value: voucher.value > 0 ? currencyFormatter.format(voucher.value) : '',
                        voucherName: voucher.name,
                    }}>
                        Congratulations {firstName}. You qualify for a {currencyFormatter.format(voucher.value)} {voucher.name} with the lease or purchase of the {newVehicleModelYear} {newVehicleModel}.
                    </Trans>
                </strong>

                <br />

                <Trans i18nKey='title' t={t} values={{
                    model: newVehicleModel,
                }}>
                    A sales representative will be in touch with you to book your walkthrough of the <strong>{newVehicleModel}</strong>. We look forward to helping you get into a new vehicle.
                </Trans>
            </span>
        </div>
    )
}

export default withTheme(supportedThemes)(withTranslation(transDomain)(withRouter((SuccessInfoArea))))
